import cx from 'classnames';

import i18n from 'i18n/config';
import { DeltaIndiaLogoMobile, DeltaLogoMobile } from 'styles/assets/icons';

import Card from './Card';
import styles from './IndiaOrGlobalModal.module.scss';

export enum CardType {
  GLOBAL = 'global.delta.exchange',
  INDIA = 'delta.exchange',
}

const deltaExchangeIndia = i18n.t('common:deltaExchangeIndia');
const deltaExchangeGlobal = i18n.t('common:deltaExchangeGlobal');

const Content = ({
  activeCard,
  changeActiveCard,
}: {
  activeCard: CardType;
  changeActiveCard: (cardType: CardType) => void;
}) => {
  return (
    (<div
      className={cx(styles.content, 'flex-set flex--column')}
      data-palette="Content">
      <Card
        data-testid="delta-india-card"
        title={deltaExchangeIndia}
        logo={<DeltaIndiaLogoMobile />}
        onClick={() => changeActiveCard(CardType.INDIA)}
        isActive={activeCard === CardType.INDIA}
        className={styles.indianCard}
      >
        <span className={styles.highlight}>{CardType.INDIA}</span> now points to Delta
        India.This exchange serves only Indian traders
      </Card>
      <Card
        data-testid="delta-global-card"
        title={deltaExchangeGlobal}
        logo={<DeltaLogoMobile />}
        onClick={() => changeActiveCard(CardType.GLOBAL)}
        isActive={activeCard === CardType.GLOBAL}
        className={styles.globalCard}
      >
        <span className={styles.highlight}>{CardType.GLOBAL}</span> points to Delta
        Global. This exchange serves traders from the rest of the world
      </Card>
    </div>)
  );
};

export default Content;
